/*
 * JOOLME — Meta click attribution for appointment requests.
 * Mirrors how gclid is already handled: the Meta click id (fbclid) is captured from the landing
 * URL on any page, kept in localStorage for 90 days, and added to every appointment request
 * (api.joolme.co.il/api/sendVirtualExperienceRequest) from both the showroom page and the
 * product-page popup, so Kala receives fbclid / fbc / fbp.
 * Values already present in a request are never overwritten. Fails silently: attribution must
 * never block a booking.
 */
(function () {
  var KEY = 'joolme_fb_click';
  var TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var ENDPOINT_MARK = 'sendVirtualExperienceRequest';

  function readCookie(name) {
    try {
      var prefix = name + '=';
      var parts = document.cookie.split(';');
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i].replace(/^\s+/, '');
        if (p.indexOf(prefix) === 0) return decodeURIComponent(p.slice(prefix.length));
      }
    } catch (e) {}
    return '';
  }

  function capture() {
    try {
      var fbclid = (new URLSearchParams(window.location.search).get('fbclid') || '').trim();
      if (!fbclid || fbclid.length > 500) return;
      var now = Date.now();
      localStorage.setItem(KEY, JSON.stringify({
        fbclid: fbclid,
        fbc: 'fb.1.' + now + '.' + fbclid,
        ts: now
      }));
    } catch (e) {}
  }

  function get() {
    var out = { fbclid: '', fbc: '', fbp: readCookie('_fbp') };
    try {
      var stored = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (stored && typeof stored.ts === 'number' && Date.now() - stored.ts <= TTL_MS) {
        if (typeof stored.fbclid === 'string') out.fbclid = stored.fbclid;
        if (typeof stored.fbc === 'string') out.fbc = stored.fbc;
      } else if (stored) {
        localStorage.removeItem(KEY);
      }
    } catch (e) {}
    // Meta's own first-party click cookie wins when present (set by the pixel).
    var cookieFbc = readCookie('_fbc');
    if (cookieFbc) out.fbc = cookieFbc;
    return out;
  }

  function enrich(data) {
    if (!data || typeof data !== 'object' || Array.isArray(data)) return data;
    var fb = get();
    ['fbclid', 'fbc', 'fbp'].forEach(function (k) {
      if (!data[k] && fb[k]) data[k] = fb[k];
    });
    if (data.fbclid || data.fbc) {
      var attrs = (data.attributes && typeof data.attributes === 'object') ? data.attributes : {};
      if (!attrs.fbclid && data.fbclid) attrs.fbclid = data.fbclid;
      if (!attrs.fbc && data.fbc) attrs.fbc = data.fbc;
      if (!attrs.gclid && data.gclid) attrs.gclid = data.gclid;
      data.attributes = attrs;
    }
    return data;
  }

  function installInterceptor() {
    if (!window.axios || !window.axios.interceptors || window.__joolmeFbInterceptor) return !!window.__joolmeFbInterceptor;
    window.__joolmeFbInterceptor = true;
    window.axios.interceptors.request.use(function (config) {
      try {
        if (config && typeof config.url === 'string' && config.url.indexOf(ENDPOINT_MARK) !== -1) {
          if (typeof config.data === 'string') {
            try { config.data = JSON.stringify(enrich(JSON.parse(config.data))); } catch (e) {}
          } else {
            config.data = enrich(config.data);
          }
        }
      } catch (e) {}
      return config;
    });
    return true;
  }

  capture();
  window.JoolmeFbAttribution = { get: get, enrich: enrich };
  if (!installInterceptor()) {
    document.addEventListener('DOMContentLoaded', installInterceptor);
    window.addEventListener('load', installInterceptor);
  }
})();
